//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      breadcrumbParams: 'ui/breadcrumbParams'
    }),
    matchedRoutes() {
      return this.$route.matched.slice(1)
    }
  },
  methods: {
    label(matchedRoute) {
      return this.$t(`routeNames.${matchedRoute.path.slice(7)}`, this.breadcrumbParams)
    },
    link(matchedRoute) {
      if (matchedRoute.path.match(/\/:/)) {
        return matchedRoute.components.default._path
      } else {
        return matchedRoute.path
      }
    }
  }
}
